import { AlertAction, AlertCloseButton, AlertRoot } from "./Alert.styles";
import { AlertProps } from "./Alert.types";
import useGetAlertIcon from "./hook/useGetAlertIcon";
import { Row } from "../Row";
import { capitalize, cx } from "../../react-utils";
import { useMergeDefaultProps } from "../../react-components-core";
import { useState } from "react";

const Alert = (props: AlertProps): JSX.Element => {
    const {
        icon: iconProp = true,
        content,
        type,
        action,
        className,
        style,
        elevation = 0,
        square,
        closable,
        onAlertClick,
    } = useMergeDefaultProps("Alert", props);

    const defaultIcon = useGetAlertIcon(type);
    const icon = iconProp === true ? defaultIcon : iconProp;
    const [closed, setClosed] = useState<boolean>(false);

    const onCloseAlert = () => {
        setClosed(true);
    };

    return (
        <AlertRoot
            type={type}
            className={cx("Alert", type && capitalize(type), className)}
            style={style}
            elevation={elevation}
            square={square}
            closed={closed}
            onClick={() => onAlertClick?.()}
            hasAlertClick={!!onAlertClick}
        >
            <Row flex={1} gap={10} wrap wrapGap={10} justifyContent="space-between">
                <Row flex={1} alignItems="center" gap={10}>
                    <Row flex={0.05}>{icon}</Row>
                    <Row flex={0.95}>{content}</Row>
                </Row>
                <AlertAction style={{ display: "flex", alignItems: "center" }}>
                    {action ? action : closable ? <AlertCloseButton onClick={onCloseAlert}>X</AlertCloseButton> : <></>}
                </AlertAction>
            </Row>
        </AlertRoot>
    );
};

export default Alert;
